exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-card[data-v-50ea99bf]{margin:.5em;min-width:300px}", ""]);

// exports
